export class ExcludedStateCodeModel {
StateCode: string;
Id: number;
}

export class ExcludedStateCodeListModel {
excludedStateCodeListModel:  Array<ExcludedStateCodeResponseModel> = []; 
}

export class ExcludedStateCodeResponseModel {
stateCode: string;
id: number;
keyword: string
}
export class UpdateExcludedStateCodeModel{
stateCode: string;
id: number;                                                                                          
}

export class ListStateCodeModel {
Id: number;
Keyword: string;
StateCode: string;
}

export class DeleteStateCodeModel {
Id: number;                                                                                                   
}

